module.exports = __webpack_public_path__ + "static/media/accountmanagement.200650c4.png";